/* @flow */
import * as React from 'react';

const Warning = props => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    {...props}>
    <rect fill="#EA7471" x={0} y={0} width={48} height={48} rx={24} />
    <path
      fill="#FFFFFF"
      d="M27.028,13.994 C27.138,12.893 26.33,12 25.22,12 L22.78,12 C21.671,12 20.861,12.883 20.972,13.994 L22.276,26.999 C22.331,27.552 22.828,28 23.368,28 L24.632,28 C25.18,28 25.668,27.555 25.724,26.999 L27.028,13.994 Z M21.683,33.615 C21.683,34.943 22.71,36 23.971,36 C25.261,36 26.317,34.943 26.317,33.615 C26.317,32.287 25.261,31.2 23.971,31.2 C22.71,31.2 21.683,32.287 21.683,33.615 Z"
    />
  </svg>
);

export default Warning;



// WEBPACK FOOTER //
// ./src/assets/images/icons/warning.js